// api.js — zentraler fetch-Wrapper mit JWT
const TOKEN_KEY = "tm_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

export async function apiFetch(path, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set("Accept", "application/json");
  if (options.body && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }
  const token = getToken();
  if (token) headers.set("Authorization", `Bearer ${token}`);

  const resp = await fetch(path, { ...options, headers });
  const text = await resp.text();
  const payload = text ? JSON.parse(text) : null;

  if (!resp.ok) {
    const msg = (payload && payload.detail) || resp.statusText || "Fehler";
    if (resp.status === 401) clearToken();
    throw new ApiError(msg, resp.status, payload);
  }
  return payload;
}

export const api = {
  login: (email, password) =>
    apiFetch("/api/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    }),
  me: () => apiFetch("/api/auth/me"),
  listTenders: (params) => {
    const qs = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v === null || v === undefined || v === "") return;
      if (Array.isArray(v)) v.forEach((x) => qs.append(k, x));
      else qs.append(k, v);
    });
    return apiFetch(`/api/tenders?${qs.toString()}`);
  },
  getTender: (id) => apiFetch(`/api/tenders/${id}`),
  getFilters: () => apiFetch("/api/filters"),
  getKeywords: () => apiFetch("/api/keywords"),
  getStats: () => apiFetch("/api/stats"),
};
